import type { ApiTypes } from "../../../index";
import { axiosInstance, handleApiError } from "../../../utils";

/**
 * cart_item-subscribe operation
 * @param params - Contains path parameters
 * @param query - Contains query parameters
 * @param request - The request data
 * @returns Promise resolving to the API response
 */
export const subscribeCartItem = async ({
  params,
  query,
  request,
}: {
  params: ApiTypes["cart_item-subscribe"]["parameters"]["path"];
  query?: ApiTypes["cart_item-subscribe"]["parameters"]["query"];
  request: ApiTypes["cart_item-subscribe"]["request"];
}): Promise<ApiTypes["cart_item-subscribe"]["response"]> => {
  try {
    const response = await axiosInstance.post<
      ApiTypes["cart_item-subscribe"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/items/${params.item_id}/subscribe`,
      request,
      { params: query },
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to subscribeCartItem: ${params.cart_token}",
    );
    throw error;
  }
};

/**
 * cart_item-unsubscribe operation
 * @param params - Contains path parameters
 * @param query - Contains query parameters
 * @returns Promise resolving to the API response
 */
export const unsubscribeCartItem = async ({
  params,
  query,
}: {
  params: ApiTypes["cart_item-unsubscribe"]["parameters"]["path"];
  query?: ApiTypes["cart_item-unsubscribe"]["parameters"]["query"];
}): Promise<ApiTypes["cart_item-unsubscribe"]["response"]> => {
  try {
    const response = await axiosInstance.delete<
      ApiTypes["cart_item-unsubscribe"]["response"]
    >(
      `/api/public/v2025-06/commerce/carts/${params.cart_token}/items/${params.item_id}/subscribe`,
      { params: query },
    );
    return response.data;
  } catch (error) {
    handleApiError(
      error as Error,
      "Failed to unsubscribeCartItem: ${params.cart_token}",
    );
    throw error;
  }
};
